<template>
  <div class="extend-input-info group">
    <div class="item info-input" v-for="(extend,index) in extendInput" v-if="isExtendShow(index)">
        <my-input
            type="text"
            :placeholder="extend.hintTxt"
            :index="index"
            :val="extendInputValue[index] || ''"
            @val-change="updateExtendValue"
            @input-focus="focusInput"
            @input-blur="blurInput">
        </my-input>
    </div>
    <div class="item text-area" v-if="isMessageBoxShow">
        <textarea
            ref="txtarea"
            v-model="message"
            placeholder="留言（选填）"
            maxlength="150"
            :style="`height:${textAreaHeight}px`"
            @focus="focusInput"
            @blur="blurInput"
        ></textarea>
    </div>
  </div>
</template>
<script>
    import { mapState } from 'vuex';
    import myInput from '../../../components/input.vue'
    import CONSTANT from '../../../constant/preorder'
    import op from "object-path"
    export default {
        props: ["productsType"],
        data() {
            return {
                message: '',
                textAreaHeight: 20,
                sto:{},//定时器
                PEODUCT_TYPE_NORMAL: CONSTANT.PREORDER_PRODUCT_TYPE_NORMAL
            }
        },
        computed: {
            ...mapState({
                extendInput: state => state.preorder.extendInput,//扩展输入框
                extendInputValue: state => state.preorder.extendInputValue, //用户输入的值
                orderType: state => state.preorder.orderType,
            }),
            isMessageBoxShow() {
              return this.productsType === this.PEODUCT_TYPE_NORMAL && this.orderType !== CONSTANT.PREORDER_ORDER_TYPE_CARDDELAY
            }
        },
        watch: {
            message(val){
                let vm = this;
                clearTimeout(this.sto)
                if(op(this.$refs).get('txtarea')){
                    this.setTxtAreaHeight();
                }else{
                    this.setTxtAreaHeight(20);
                }
                this.$store.commit('setFeedbackMsg',val)
                this.sto = setTimeout(() => {
                    vm.$refs.txtarea.blur();
                }, 4000);
            },

        },
        methods: {
            focusInput() {
                this.$emit('input-focus')
            },
            blurInput() {
                this.$emit('input-blur')
            },
            isExtendShow(index){
                 if(this.extendInput[index].attrId == CONSTANT.PREORDER_ATTR_ID_MOBILE ||
                  this.extendInput[index].attrId == CONSTANT.PREORDER_ATTR_ID_OILCARD ||
                  this.extendInput[index].attrId == CONSTANT.PREORDER_ATTR_ID_ADDRESS ||
                  this.extendInput[index].attrId == CONSTANT.PREORDER_ATTR_ID_IDCARD||
                  this.extendInput[index].attrId == CONSTANT.PREORDER_ATTR_ID_NAME){
                    return false
                }
                return true
            },
            updateExtendValue(val,index) {
                this.$store.commit('updateExtendValue',{
                    index: index,
                    value: val,
                })
            },
            setTxtAreaHeight(x) {
                let vm = this;
                if(x) {
                    setTimeout(() => {
                        return vm.textAreaHeight = x
                    }, 100);
                }else {
                    setTimeout(() => {
                        return vm.textAreaHeight = vm.$refs.txtarea.scrollHeight
                    }, 100);
                }
            }
        },
        components: {
            myInput,
        }

    }
</script>
